import BaseballResultsProcessor from "../entities/BaseballResultsProcessor.js";
import PitchData from "../enums/PitchData.js";
import PitchResultCombined from "../enums/PitchResultCombined.js";
import ScoringData from "../enums/ScoringData.js";
import EnumValueProvider from "./EnumValueProvider.js";

const UniqueResultParametersProvider = function(results, parameterPaths, customResultsProcessor, combinedPitchResult) {
    if (!results || !(results instanceof Array)) {
        throw new TypeError('results should be an array');
    }

    if (!(parameterPaths instanceof Array)) {
        throw new TypeError('parameterPath must be an array');
    }

    if (typeof(combinedPitchResult) !== 'undefined') {
        if (typeof(combinedPitchResult) !== 'boolean'){
            throw new TypeError('combinedPitchResult must be undefined or boolean');
        }
    }
    else {
        combinedPitchResult = false;
    }

    // TODO - make it stateless!
    const resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    const uniqueSets = new Map();
    
    for (let i = 0; i < parameterPaths.length; i++) {
        const path = parameterPaths[i];
        if (!(path instanceof Array) || !path.length) {
            continue;
        }

        const propertyName = path[path.length - 1];

        if (propertyName === PitchData.Result.key && combinedPitchResult) {
            const pitchResultMap = {};
            const uniqueValues = [];
            Object
                .values(PitchResultCombined)
                .filter(pr => pr.pitchResult)
                .forEach(pr => pitchResultMap[pr.pitchResult] = pr)
            ;

            for (const result of results) {
                const pitchResult = resultsProcessor.getObjectContent(result, path);
                // look for pitch result...
                if (pitchResult && pitchResultMap[pitchResult]) {
                    uniqueValues.push(pitchResultMap[pitchResult].key);
                    continue;
                }

                // look for new scoring data...
                const pitchCall = resultsProcessor.getObjectContent(result, path.slice(0, -1).concat([ScoringData.PitchCall.key]));
                const paResult = resultsProcessor.getObjectContent(result, path.slice(0, -1).concat([ScoringData.PlateAppearanceResult.key]));

                if (pitchCall && paResult) {
                    const targetEnum = EnumValueProvider.getValue(
                        `${pitchCall}-${paResult}`, PitchResultCombined
                    );
                    if (targetEnum) {
                        uniqueValues.push(targetEnum.key);
                    }
                }
            }
            // let's skip duplicates
            uniqueSets.set(propertyName, uniqueValues.filter((v, i, a) => a.indexOf(v) === i));
        }
        else {
            uniqueSets.set(propertyName, resultsProcessor.getUniqueValuesRecursive(
                false, results, [[[]].concat(path)]
            ));
        }
    }

    return uniqueSets;
};

export default UniqueResultParametersProvider;